<template>
  <div class="content">
    <van-sticky>
      <van-steps :active="active" active-icon="success" active-color="#38f">
        <van-step>司机信息</van-step>
        <van-step>车头信息</van-step>
        <van-step>车挂信息</van-step>
        <van-step>载货信息</van-step>
        <van-step>预约</van-step>
        <van-step>签署</van-step>
      </van-steps>
    </van-sticky>

    <!-- 司机未审核通过时的提示 -->
    <div
      v-if="active === 0 && driverId && driverBpmStatus !== '3'"
      class="driver-audit-tip"
    >
      <van-icon name="warning-o" size="22" color="#ff976a" />
      <div class="tip-content">
        <h4>司机审核未通过</h4>
        <p>您选择的司机未通过审核，请联系客服进行处理。</p>
        <div class="contact-btn" @click="callCustomerService">联系客服</div>
      </div>
    </div>

    <keep-alive>
      <component
        :ref="componentsMap[active] + 'Ref'"
        :is="activeComponent"
        v-bind="componentProps"
        :agreement-data="agreement"
        @update-props="handlePropsUpdate"
        @update-info="updateInfo"
      ></component>
    </keep-alive>

    <div class="option-box">
      <div class="back-btn-box">
        <van-button type="default" block @click="backActive">返回</van-button>
      </div>
      <div v-if="active !== componentsMap.length - 1" class="next-btn-box">
        <van-button
          type="default"
          block
          @click="changeActive"
          color="#316892"
          :disabled="active === 0 && driverId && driverBpmStatus !== '3'"
        >
          下一步
        </van-button>
      </div>
      <div v-else class="next-btn-box">
        <van-button
          v-if="!imgUrl"
          type="default"
          block
          color="#316892"
          @click="handleSign"
        >
          签名
        </van-button>
        <van-button
          v-else
          type="default"
          block
          color="#316892"
          @click="changeShowPayMethod"
        >
          确认
        </van-button>
      </div>
    </div>

    <!-- 金额结算弹出层 -->
    <van-popup
      v-model="showPayMethod"
      round
      closeable
      position="bottom"
      :style="{ maxHeight: '65vh', minHeight: 'auto' }"
    >
      <div class="pay-method-box">
        <div class="pay-method-radio-box" v-if="steamChargeitemList">
          <div class="chargeitem-list" v-if="!isShowCarBind">
            <div class="chargeitem-item">
              <div>品种：</div>
              <div>{{ steamChargeitemList.pinming }}</div>
            </div>
            <div class="chargeitem-item">
              <div style="font-weight: 700">作业方式</div>
              <div></div>
            </div>
            <div
              class="chargeitem-item"
              v-for="item in steamChargeitemList.jgDetail"
              :key="item.id"
            >
              <div>{{ item.zyfs }}</div>
              <div v-if="steamChargeitemList.haveYh">
                <span class="before-discount-monery" style="margin-right: 5px">
                  ￥{{ item.zxjg }}
                </span>
                <span style="color: red">￥{{ item.zxjgyh }}</span>
              </div>
              <div v-else>￥{{ item.zxjg }}</div>
            </div>
            <div class="chargeitem-item">
              <div>总计：</div>
              <div>￥{{ steamChargeitemList.zxyj }}</div>
            </div>
            <div class="chargeitem-item" v-if="steamChargeitemList.haveYh">
              <div>折扣优惠：</div>
              <div class="discount-monery">-￥{{ steamChargeitemList.yh }}</div>
            </div>
            <div class="chargeitem-item" v-if="steamChargeitemList.isUseCoupon">
              <div>优惠券：</div>
              <div class="discount-monery">
                -￥{{ steamChargeitemList.yhq }}
              </div>
            </div>
            <div class="chargeitem-item" v-if="steamChargeitemList.haveTsyh">
              <div>特殊优惠：</div>
              <div class="discount-monery">
                -￥{{ steamChargeitemList.tsyh }}
              </div>
            </div>
          </div>
          <div class="show-pay-total-money" v-if="!isShowCarBind">
            合计：
            <span class="discount-monery">￥{{ totalMoney }}</span>
            <span
              v-if="
                steamChargeitemList.haveTsyh ||
                steamChargeitemList.haveYh ||
                steamChargeitemList.isUseCoupon
              "
              class="before-discount-monery"
            >
              ￥{{ steamChargeitemList.zxyj }}
            </span>
          </div>
          <van-radio-group v-model="payMethod">
            <van-cell-group>
              <van-cell v-if="isShowCarBind" title="公司统一支付" clickable @click="payMethod = '1'">
                <template #right-icon>
                  <van-radio name="1" />
                </template>
              </van-cell>
              <van-cell v-if="!isShowCarBind" title="个体支付" clickable @click="payMethod = '2'">
                <template #right-icon>
                  <van-radio name="2" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </div>
        <div class="confirm-btn-box">
          <van-button
            color="#316892"
            block
            @click="onConfirmPayMethod"
            :loading="yyloading"
          >
            确认
          </van-button>
        </div>
      </div>
    </van-popup>
    <!-- <Tabbar></Tabbar> -->
  </div>
</template>
<script>
  import dayjs from 'dayjs';
  import Tabbar from '@/views/Public/tabbarTpl.vue';
  import ChetouList from '@/components/SteamComponents/chetouList.vue';
  import CheguaList from '@/components/SteamComponents/cheguaList.vue';
  import UserInfoCheck from '@/components/SteamComponents/userInfoCheck.vue';
  import PinzhongList from '@/components/SteamComponents/pinzhongList.vue';
  import ChoseAppointment from '@/components/SteamComponents/choseAppointment.vue';
  import SignAggreement from '@/pages/SteamAppointment/components/signAggreement.vue';
  import steamApi from '@/fetch/steamApi';
  import api from '@/fetch/api.js';
  import { Toast, Dialog } from 'vant';
  export default {
    components: {
      Tabbar,
      ChetouList,
      CheguaList,
      UserInfoCheck,
      PinzhongList,
      ChoseAppointment,
      SignAggreement,
    },
    data() {
      return {
        active: 0,
        isNext: false,
        showBack: false,
        componentsMap: [
          'UserInfoCheck',
          'ChetouList',
          'CheguaList',
          'pinzhongList',
          'choseAppointment',
          'SignAggreement',
        ],
        isFinish: false,
        driverId: '',
        driverName: '',
        driverPhone: '',
        driverIdCard: '',
        driverBpmStatus: '',
        customerServicePhone: '400-123-4567',
        chetouhaoId: '',
        chetouhaoName: '',
        cheguahaoName: '',
        cheguahaoId: '',
        beizhu: '',
        pzImage: [],
        pzInfo: [],
        appointmentDate: '', // 预约日期
        cangshi: '',
        xingshizhenghdzzl: 0,
        zongzhiliang: 0,
        appointmentStartdate: '',
        appointmentEnddate: '',
        appointmentPdxx: '',
        showPayMethod: false,
        payMethod: '1',
        selectedPayMethod: '',
        yyloading: false,
        appointmentPdxxId: '',
        tankMaterial: '', // 罐体材质
        componentProps: {},
        maxFee: 0,
        cargoHoldsNumbs: localStorage['cheguashu'] || '', // 货舱数
        isOilSpillProbe: '', // 是否有溢油探头
        previousLoc: '',
        nextLoc: '',
        variety: '', // 上一载品种
        nextVariety: '',
        computeMoney: 0,
        steamChargeitemList: {}, // 结算信息
        totalMoney: 0,
        chargeitemTitle: '',
        chargeitem: '',
        // 签名图片base64
        imgUrl: '',
        agreement: {
          appointmentCode: '', // 预约编号
          driverName: '',
          idCard: '',
          cardNumber: '',
          price: '',
          singTime: '',
          variety: '',
        },
        isShowCarBind: true,
      };
    },
    computed: {
      activeComponent() {
        // 返回当前活动的组件
        return this.componentsMap[this.active];
      },
    },
    created() {
      document.title = '槽车蒸洗预约';
    },
    methods: {
      // 拨打客服电话
      callCustomerService() {
        window.location.href = `tel:${this.customerServicePhone}`;
      },

      // 组件内部数据触发的自定义事件
      updateInfo(infoType, data) {
        switch (infoType) {
          case 'driver':
            this.driverId = data.id;
            this.driverName = data.name;
            this.driverPhone = data.telphone;
            this.driverIdCard = data.shenfenzheng;
            this.driverBpmStatus = data.bpmStatus || '';

            if (this.driverBpmStatus && this.driverBpmStatus !== '3') {
              Toast('该司机尚未审核通过，请联系客服处理');
            }
            break;
          case 'chetouhao':
            this.chetouhaoId = data.id;
            this.chetouhaoName = data.chetouhao;

            break;
          case 'cheguahao':
            this.cheguahaoId = data.id;
            this.cheguahaoName = data.cheguahao;
            localStorage['cheguashu'] = data.cssl
              ? String(parseInt(data.cssl))
              : '';
            this.cargoHoldsNumbs = localStorage['cheguashu'];
            this.xingshizhenghdzzl = data.xingshizhenghdzzl;
            this.cangshi = data.cangshi;
            this.zongzhiliang = data.zhengbeizhiliang;
            this.tankMaterial = data.guanticaizhi;
            break;
          case 'beizhu':
            this.beizhu = data;
            break;
          case 'pzImage':
            this.pzImage = data;
            break;
          case 'previousLoc':
            this.previousLoc = data;
            break;
          case 'nextLoc':
            this.nextLoc = data;
            break;
          case 'variety':
            this.variety = data.pinming;
            break;
          case 'nextVariety':
            this.nextVariety = data.pinming;
            break;
          case 'appointmentDate':
            this.appointmentDate = data;
            break;
          case 'appointmentPdxxInfo':
            this.appointmentStartdate = data.qssj;
            this.appointmentEnddate = data.zzsj;
            this.appointmentPdxx = data.sjd;
            this.appointmentPdxxId = data.id;
            break;
          case 'guanticaizhi':
            this.tankMaterial = data;
            this.handlePropsUpdate(false);
            break;
          case 'cargoHoldsNumbs':
            this.cargoHoldsNumbs = data;
            break;
          case 'agreement':
            this.imgUrl = data;
            break;
          case 'isOilSpillProbe':
            this.isOilSpillProbe = data;
            break;
          default:
        }
      },

      // ----------校验字段是否为空----------
      // 上一载品种是否为空
      validateVariety() {
        return new Promise((resolve, reject) => {
          if (this.active >= 3 && !this.variety) {
            reject('请填写上一载品种');
          } else {
            resolve();
          }
        });
      },

      // 罐体材质是否为空
      validateTankMaterial() {
        return new Promise((resolve, reject) => {
          if (this.active >= 4 && !this.tankMaterial) {
            reject('请选择罐体材质');
          } else {
            resolve();
          }
        });
      },

      // 货舱数是否为空
      validateCargoHoldsNumbs() {
        return new Promise((resolve, reject) => {
          if (this.active >= 4 && !this.cargoHoldsNumbs) {
            reject('请选择货舱数');
          } else {
            resolve();
          }
        });
      },

      // 是否有溢油探头是否为空
      validateIsOilSpillProbe() {
        return new Promise((resolve, reject) => {
          if (this.active >= 4 && !this.isOilSpillProbe) {
            reject('请选择是否有溢油探头');
          } else {
            resolve();
          }
        });
      },

      // 预约日期是否为空
      validateAppointmentDate() {
        return new Promise((resolve, reject) => {
          if (this.active >= 4 && !this.appointmentDate) {
            reject('请选择预约日期');
          } else {
            resolve();
          }
        });
      },

      // 可用时间是否为空
      validateKYSJ() {
        return new Promise((resolve, reject) => {
          if (this.active >= 4) {
            if (
              this.appointmentStartdate &&
              this.appointmentEnddate &&
              this.appointmentPdxx &&
              this.appointmentPdxxId
            ) {
              resolve();
            } else {
              reject('请选择可用时间');
            }
          } else {
            resolve();
          }
        });
      },

      // 字段校验通用方法
      validateField() {
        return new Promise((resolve, reject) => {
          Promise.all([
            this.validateVariety(),
            this.validateTankMaterial(),
            this.validateCargoHoldsNumbs(),
            this.validateIsOilSpillProbe(), //是否有溢油探头校验
            this.validateAppointmentDate(),
            this.validateKYSJ(), // 可用时间校验
          ])
            .then(() => {
              resolve();
            })
            .catch((error) => {
              reject(error);
            });
        });
      },
      //下一页(含当前页字段校验)
      changeActive() {
        if (
          this.active === 0 &&
          this.driverId &&
          this.driverBpmStatus !== '3'
        ) {
          Toast.fail('请选择已通过审核的司机');
          return;
        }

        // 字段校验
        this.validateField()
          .then(async () => {
            if (this.active === 4) {
              // 预约
              var appointmentTime = this.appointmentDate;
              var headstock = this.chetouhaoName;
              if (!headstock) {
                Toast.fail('请确认车头信息是否正确');
                return;
              }
              var handnum = this.cheguahaoName;
              if (!handnum) {
                Toast.fail('请确认车挂信息是否正确');
                return;
              }
              var postData = {
                openid: this.$store.state.wx_info.openid,
                yyrq: appointmentTime,
                chetouhao: headstock,
                cheguahao: handnum,
                cheguacaizhi: this.tankMaterial,
                shangyizaipinzhong: this.variety,
              };
              const res = await steamApi.querySteamChargeitem(postData);
              var resData = JSON.parse(res);
              if (resData.respCode == '0') {
                this.steamChargeitemList = resData.data;
                // console.log(JSON.parse(res).data[0].steamChargeitemFee);
                this.agreement.driverName = this.driverName;
                this.agreement.idCard = this.driverIdCard;
                this.agreement.cardNumber = `${this.chetouhaoName}/${this.cheguahaoName}挂`;
                this.agreement.price = JSON.parse(res).data.zzjg;
                // prettier-ignore
                this.agreement.singTime = dayjs(new Date()).format('YYYY-MM-DD');
                this.agreement.variety = this.variety;
              } else {
                Toast.fail(resData.message);
                return;
              }
            }
            // 下一页
            this.active = this.active + 1;
          })
          .catch((error) => {
            Toast.fail(error);
          });
      },

      // 上一页
      backActive() {
        if (this.active <= 0) {
          this.$router.back();
        }
        this.active = this.active - 1;
      },

      handlePropsUpdate(isNext) {
        this.isNext = isNext;
        if (this.active == 4) {
          this.componentProps = { gtMaterial: this.tankMaterial };
        }
      },
      // changeShowPayMethodShow() {
      //   Dialog.confirm({
      //     title: '警告',
      //     message: '点击确认后优惠券将自动使用并且无法退回',
      //   })
      //     .then(() => {
      //       this.showPayMethod = true;
      //       this.changeShowPayMethod();
      //     })
      //     .catch(() => {
      //       // on cancel
      //     });
      // },
      async getCarBound() {
        try {
          const res = await steamApi.getController(this.chetouhaoName);
          const resData = JSON.parse(res)
          if(resData) {
            this.isShowCarBind = resData.success
          }
          if (!this.isShowCarBind) {
            this.payMethod = '2'
          } else {
            this.payMethod = '1'
          }
        } catch (error) {
          Toast.fail('连接失败，请刷新页面')
          return false;
        }
      },
      // 金额结算弹出层
      async changeShowPayMethod() {
        this.showPayMethod = true;
        var that = this;
        // 校验字段
        this.validateField()
          .then(async function () {
            // 预约

            var appointmentTime = that.appointmentDate;

            var headstock = that.chetouhaoName;
            if (!headstock) {
              Toast.fail('请确认车头信息是否正确');
              return;
            }

            var handnum = that.cheguahaoName;
            if (!handnum) {
              Toast.fail('请确认车挂信息是否正确');
              return;
            }

            var tankMaterial = that.tankMaterial;
            if (!tankMaterial) {
              Toast.fail('请选择罐体材质');
              return;
            }

            await that.getCarBound()

            var postData = {
              openid: that.$store.state.wx_info.openid,
              yyrq: appointmentTime,
              chetouhao: headstock,
              cheguahao: handnum,
              cheguacaizhi: tankMaterial,
              shangyizaipinzhong: that.variety,
            };
            return steamApi.querySteamChargeitem(postData);
          })
          .then(function (res) {
            var resData = JSON.parse(res);
            if (resData.respCode == '0') {
              // var steamChargeitemList = resData.data;
              // that.steamChargeitemList = steamChargeitemList;
              var chargeitemTitle = '';
              var chargeitem = ' ';
              // steamChargeitemList.forEach(function (item) {
              //   totalMoney += item.steamChargeitemFee;
              //   chargeitemTitle += item.steamChargeitemTitle + ',';
              //   chargeitem += item.steamChargeitemId + ',';
              // });

              that.totalMoney = that.steamChargeitemList.zzjg;
              that.chargeitemTitle = chargeitemTitle;
              that.chargeitem = chargeitem;
            } else {
              Toast.fail(resData.message);
              that.yyloading = false;
            }
          })
          .catch(function (err) {
            Toast.fail(err);
            console.log('err', err);
          });
      },

      // 预约确认按钮
      onConfirmPayMethod() {
        // 个体支付
        if (this.payMethod == '2') {
          Dialog.confirm({
            message: '需要付款金额' + this.totalMoney + '元',
          })
            .then(() => {
              // on confirm
              this.yyloading = true;
              this.selectedPayMethod = this.payMethod;
              this.yuyueActive();
            })
            .catch(() => {
              this.yyloading = false;
              // on cancel
            });
        } else {
          // 对公支付
          this.yyloading = true;
          this.selectedPayMethod = this.payMethod;
          this.yuyueActive();
        }
      },

      // 预约
      async yuyueActive() {
        var that = this;
        var openid = this.$store.state.wx_info.openid;
        // 非空校验
        var headstock = that.chetouhaoName;
        if (!headstock) {
          Toast.fail('请确认车头信息是否正确');
          that.yyloading = false;
          return;
        }
        var handnum = that.cheguahaoName;
        if (!handnum) {
          Toast.fail('请确认车挂信息是否正确');
          that.yyloading = false;
          return;
        }
        var appointmentTime = that.appointmentDate;
        if (!appointmentTime) {
          Toast.fail('请确认司机信息是否正确');
          that.yyloading = false;
          return;
        }
        var driverName = that.driverName;
        var driverId = that.driverId;
        var driverPhone = that.driverPhone;
        var cangshi = that.cangshi;
        var xingshizhenghdzzl = that.xingshizhenghdzzl;
        var zongzhiliang = that.zongzhiliang;
        if (!driverId) {
          Toast.fail('请选择正确的司机信息');
          that.yyloading = false;
          return;
        }
        var chargeitem = that.chargeitem;
        var chargeitemTitle = that.chargeitemTitle;
        var payMethod = that.selectedPayMethod;
        if (!payMethod) {
          Toast.fail('请选择正确的支付方式');
          that.yyloading = false;
          return;
        }
        // 构造请求
        var beizhu = this.beizhu;
        var appointmentPdxxId = this.appointmentPdxxId;
        var pzImage = this.pzImage.length > 0 ? this.pzImage[0].url : '';
        var postData = {
          headstock: headstock,
          handnum: handnum,
          appointmentTime: appointmentTime,
          poundListUrl: pzImage,
          driverName: driverName,
          drivePhone: driverPhone,
          loadWeight: xingshizhenghdzzl,
          totalWeight: zongzhiliang,
          compartmentCount: cangshi,
          driverOpenid: openid,
          driverId: driverId,
          steamChargeitemId: chargeitem,
          steamChargeitemTitle: chargeitemTitle,
          steamChargeitemFee: that.totalMoney * 100,
          appointmentStartdate: that.appointmentStartdate,
          appointmentEnddate: that.appointmentEnddate,
          appointmentPdxx: that.appointmentPdxx,
          payMethod: payMethod,
          remark: beizhu,
          pdxxid: appointmentPdxxId,
          tankMaterial: that.tankMaterial,
          variety: this.variety,
          nextVariety: this.nextVariety,
          previousLoc: this.previousLoc,
          nextLoc: this.nextLoc,
          cargoHoldsNumbs: this.cargoHoldsNumbs,
          isOilSpillProbe: this.isOilSpillProbe,
        };
        try {
          // 提交预约
          const res = await steamApi.steamAddAppointment(postData);
          const resData = JSON.parse(res);
          // 预约失败:
          if (resData.respCode !== '0') {
            Toast.fail(resData.message);
            that.yyloading = false;
            return;
          }
          // 预约成功:
          that.yyloading = false;
          that.showPayMethod = false;
          const appointment = resData.data;
          // 设置协议编号
          that.agreement.appointmentCode = appointment.appointno[0];
          // 生成并提交协议
          await that.submitAgreement();
          // 根据支付方式处理
          if (that.selectedPayMethod == 2) {
            // 个人支付（等待支付结果）
            const paySuccess = await that.goSteamWechatPay(
              appointment.appointid[0]
            );
            if (paySuccess) {
              // 支付成功后的操作
              that.$router.push({ name: 'index' });
            } else {
              that.$router.push({ name: 'orderlist' });
            }
          } else {
            // 对公支付
            Dialog.alert({
              message: '预约成功',
            }).then(() => {
              that.$router.push({ name: 'index' }); //steamCleanHome
            });
          }
        } catch (error) {
          console.error('预约流程错误', error);
          Toast.fail('操作失败，请重试');
          that.yyloading = false;
        } finally {
          that.yyloading = false;
        }
      },

      // 个人支付
      async goSteamWechatPay(appointmentId) {
        const postData = {
          openid: this.$store.state.wx_info.openid,
          userId: this.$store.state.userid,
          username: this.$store.state.wx_info.username,
        };

        try {
          const res = await steamApi.steamWechatPayCreateOrder(
            appointmentId,
            postData
          );
          const resData = JSON.parse(res);

          if (resData.respCode !== '0') {
            Toast.fail('支付错误', resData.message);
            this.yyloading = false;
            return false; // 明确返回失败
          }

          // 封装微信支付为 Promise
          return new Promise((resolve) => {
            window.WeixinJSBridge.invoke(
              'getBrandWCPayRequest',
              {
                appId: resData.data.appid,
                timeStamp: resData.data.timeStamp,
                nonceStr: resData.data.nonceStr,
                package: 'prepay_id=' + resData.data.prepayId,
                signType: resData.data.signType,
                paySign: resData.data.paySign,
              },
              (res) => {
                if (res.err_msg === 'get_brand_wcpay_request:ok') {
                  Toast('支付成功');
                  resolve(true); // 支付成功返回 true
                } else {
                  Toast(
                    res.err_msg.includes('cancel') ? '取消支付' : '支付失败'
                  );
                  resolve(false); // 支付失败返回 false
                }
              }
            );
          });
        } catch (error) {
          Toast.fail('连接失败，请刷新页面');
          return false;
        }
      },

      // 签字
      handleSign() {
        this.$refs.SignAggreementRef.confirmSignature();
      },

      // 生成并提交协议
      async submitAgreement() {
        this.$store.commit('set_isLoading', true);
        // 生成协议PDF
        const data = {
          driverName: this.agreement.driverName,
          idCard: this.agreement.idCard,
          cardNumber: this.agreement.cardNumber,
          number: this.agreement.appointmentCode,
          price: this.agreement.price + '元',
          singTime: this.agreement.singTime,
          imgbase64: this.imgUrl,
          pinzhong: this.variety,
        };
        return api
          .createAgreementPdf(data)
          .then(async (res) => {
            const textPreview = await this.previewBlobText(res, 10);
            if (textPreview.startsWith('%PDF')) {
              // 获取PDF二进制流
              const downloadUrl = new Blob([res], { type: 'application/pdf' });
              // 转换为File对象
              const file = new File(
                [downloadUrl],
                `${this.agreement.appointmentCode}.pdf`,
                { type: downloadUrl.type }
              );
              console.log(file);
              let formData = new FormData();
              formData.append('file', file);
              // 上传PDF
              return api.uploadAgreement(formData);
            } else {
              throw new Error('生成协议失败');
            }
          })
          .then((res) => {
            // 上传成功获取协议url
            const data = {
              xieyibianhao: this.agreement.appointmentCode,
              qianzibase64: this.imgUrl,
              cheguahao: this.cheguahaoName,
              driverName: this.driverName,
              fileUrl: res.obj.url,
              status: 0,
              // pinzhong: this.variety,
            };
            console.log('协议上传完成');
            // 提交协议
            return api.addAgreement(data);
          })
          .catch((err) => {
            throw new Error(err);
          })
          .finally(() => {
            this.$store.commit('set_isLoading', false);
          });
      },

      // 辅助函数：预览Blob的文本内容
      previewBlobText(blob, maxLength = 100) {
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.onload = () => {
            const text = reader.result.slice(0, maxLength);
            resolve(text);
          };
          reader.readAsText(blob);
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .content {
    margin: 1rem 0 3.75rem;
    padding-bottom: env(safe-area-inset-bottom);
    position: relative;
  }

  /* 司机审核提示样式 */
  .driver-audit-tip {
    margin: 1rem;
    padding: 1rem;
    background-color: #fff7e8;
    border-radius: 8px;
    display: flex;
    align-items: flex-start;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    border-left: 4px solid #ff976a;
    z-index: 10;

    .tip-content {
      margin-left: 0.8rem;
      flex: 1;

      h4 {
        margin: 0 0 0.5rem 0;
        color: #ed6a0c;
        font-size: 16px;
      }

      p {
        margin: 0;
        color: #666;
        font-size: 14px;
        line-height: 1.5;
      }

      .contact-btn {
        margin-top: 0.8rem;
        display: inline-block;
        padding: 0.4rem 1rem;
        background-color: #ff976a;
        color: white;
        border-radius: 16px;
        font-size: 14px;
        box-shadow: 0 2px 5px rgba(255, 151, 106, 0.3);
        transition: all 0.2s;

        &:active {
          background-color: #f37335;
          transform: scale(0.98);
        }
      }
    }
  }

  ::v-deep .van-step__circle-container {
    z-index: 0 !important;
  }

  .option-box {
    background-color: #fff;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 20px;
    z-index: 2;
    .back-btn-box {
      width: 49%;
      float: left;
    }
    .next-btn-box {
      width: 45%;
      float: right;
    }
    .finish-btn-box {
      width: 45%;
      float: right;
    }
  }

  .pay-method-box {
    margin-top: 3rem;
    position: relative;
    .show-pay-total-money {
      font-size: 150%;
      margin: 0 0 1rem 1rem;
      font-weight: bold;
    }
    .chargeitem-list {
      margin: 0 0 1rem 1rem;
    }

    .chargeitem-item {
      display: flex;
      justify-content: space-between;
      padding-right: 1rem;
      margin-bottom: 0.5rem;
    }

    .confirm-btn-box {
      margin: 2rem 1rem;
    }
    .discount-monery {
      color: red;
    }
    .before-discount-monery {
      font-size: 87%;
      text-decoration: line-through;
      color: #ccc;
    }
  }

  /* 禁用按钮样式 */
  ::v-deep .van-button--disabled {
    opacity: 0.6;
    background-color: #ccc !important;
  }
</style>
